import { HTMLExtUtils } from '@ssml-editor/core';
import { Alphabet } from './alphabet.enum.js';
import { PHONEME_TYPE } from './constant.js';

const phonemeHtmlToElement = ({
  element,
  children
}) => {
  const mark = HTMLExtUtils.getDataAttribute(element, "mark", "");
  const alphabet = Alphabet.fromString(
    HTMLExtUtils.getDataAttribute(element, "alphabet", "py")
  ) || Alphabet.PY;
  const ph = HTMLExtUtils.getDataAttribute(element, "ph", "");
  return {
    type: PHONEME_TYPE,
    mark,
    alphabet,
    ph,
    children
  };
};

export { phonemeHtmlToElement };
//# sourceMappingURL=html-to-element.js.map
